const Cryptr = require('cryptr');
const cryptr = new Cryptr('bLuEM@nG0es');

export const TokenService = (type, payload) => {

    return async () => {
        // console.log(payload, type);
        console.log("token service called", payload);
        if(type === 'setToken'){
            localStorage.setItem(payload.key, JSON.stringify(payload.value));
            return null;
        }
        else if(type === 'getToken'){
            if(localStorage.getItem(payload)){
                return JSON.parse(localStorage.getItem(payload));
            }
        }
        else if(type === 'removeToken'){
            localStorage.removeItem(payload);
            return null;
        }
    }
}